import validationRules from "../validationRules";
validationRules.register("between", function (record, fieldMetadataMap, fieldName, t) {
    var args = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args[_i - 4] = arguments[_i];
    }
    var max = args[1] || undefined;
    var min = args[0] || undefined;
    var value = record[fieldName] || "";
    if ((!min && !max) || (value.min < min && value.max > max)) {
        return true;
    }
    var fieldMetadata = fieldMetadataMap.get(fieldName);
    if (["varchar", "name"].includes(fieldMetadata.type)) {
        return "should be between ".concat(min, " and ").concat(max, ".");
    }
    else if (["int"].includes(fieldMetadata.type)) {
        if (value >= parseInt(min) && value <= parseInt(max)) {
            return true;
        }
        else {
            return "should be between ".concat(min, " and ").concat(max, ".");
        }
    }
    return true;
});
